import { tap } from 'rxjs/operators';
import { ConstantsService } from '../constants/constants.service';
import { ToastrService } from 'ngx-toastr';

import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptorFn, HttpErrorResponse, HttpHandlerFn } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { IdleService } from '../services/idle.service';

declare var $:any;

export const errorHandlerInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  
  const router = inject(Router);
  const toastr = inject(ToastrService);
  const constants = inject(ConstantsService);
  const idleService = inject(IdleService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Check if current route is a visitor QR form route
      const isVisitorRoute = router.url.includes('/scan-qr-visit-form') || 
                            router.url.includes('/visit-invite-form') || router.url.includes('/visitor-badge');

      if (error.status === 0) {
        if (!navigator.onLine) {
          toastr.error('No internet connection. Please check your network and try again.', '', {
            timeOut: 6000,
            closeButton: true,
          });
        } else {
          toastr.warning('Application is under maintenance. Please try again later.', '', {
            timeOut: 6000,
            closeButton: true,
          });
        }
        return throwError(() => error);
      }                      
      if (error.status === 401) {
        if (constants.getSession()) {
          toastr.clear(); 
          idleService.stopIdleWatch();
          toastr.error(constants.MESSAGES['UNAUTHORIZED']);
        }
        if (!isVisitorRoute) {
          clearSessionAndNavigate(router, constants);
        }
      } else if(error.status === 403){
        if (constants.getSession()) {
          toastr.clear();
          idleService.stopIdleWatch();
          toastr.error(constants.MESSAGES['FORBIDDEN']);
        }
        if (!isVisitorRoute) {
          clearSessionAndNavigate(router, constants);
        }
      } else {
        // Handle other errors (409, 500, etc.)
        if(error.error && error.error.message){
          toastr.error(error.error.message);
        } else {
          toastr.error(constants.MESSAGES['ERROR']);
        }
        // Only logout for 401/403
        if (!isVisitorRoute && (error.status === 401 || error.status === 403)) {
          clearSessionAndNavigate(router, constants);
        }
      }

      return throwError(() => error);
    })
  );
};
function clearSessionAndNavigate(router: Router, constants: ConstantsService) {
  try {
    // Clear session from constants service if available
    constants.clearSession?.();

    // Clear all storages
    localStorage.clear();
    sessionStorage.clear();

    // Navigate to login
    router.navigate(['/login']);
  } catch (e) {
    console.error('Error clearing session:', e);
    router.navigate(['/login']);
  }
}